
<div *ngIf="!isError && loadError && !error" role="alert" class="container w-80 mt-10">
  <div class="bg-blue-500 text-white font-bold rounded-t px-4 py-2">
    Success
  </div>
  <div
    class="border border-t-0 border-blue-400 rounded-b bg-blue-100 px-4 py-3 text-blue-700"
  >
    <p>{{ message }}</p>
  </div>
</div>
<div *ngIf="!isError && loadError && error" role="alert" class="container w-80 mt-10">
  <div class="bg-rose-500 text-white font-bold rounded-t px-4 py-2">
    Success
  </div>
  <div
    class="border border-t-0 border-blue-400 rounded-b bg-blue-100 px-4 py-3 text-blue-700"
  >
    <p>{{ message }}</p>
  </div>
</div>

<div *ngIf="isError && loadError" role="alert" class="container mx-auto mt-10">
  <div class="bg-red-500 text-white font-bold rounded-t px-4 py-2">Danger</div>
  <div
    class="border border-t-0 border-red-400 rounded-b bg-red-100 px-4 py-3 text-red-700"
  >
    <p>Something not ideal might be happening. {{ message }}</p>
  </div>
</div>
<div class="w-full max-w-xs mx-auto container mt-28">
  <div *ngIf="isSuccess"  class="bg-indigo-900 text-center py-4 lg:px-4 mb-5 rounded ">
    <div
      class="p-2 bg-indigo-800 items-center text-indigo-100 leading-none lg:rounded-full flex lg:inline-flex"
      role="alert"
    >
      <span
        class="flex rounded-full bg-indigo-500 uppercase px-2 py-1 text-xs font-bold mr-3"
      >
        OK
      </span>
      <span class="font-semibold mr-2 text-left flex-auto">
        {{message}}, Thank You !
      </span>
    </div>
  </div>
  <form
    [formGroup]="formRegis"
    (ngSubmit)="doRegis()"
    class=" shadow-lg rounded px-8 pt-6 pb-8 mb-4"
  >
    <div *ngIf="!isLoginMode" class="mb-4">
      <label class="block text-gray-700 text-sm font-bold mb-2" for="email">
        Name
      </label>
      <input
        class="input appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none "
        id="name"
        type="name"
        placeholder="name"
        formControlName="name"
        name="name"
        maxLength="20"
      />
      <small class="text-danger" *ngIf="formRegis.invalid && formRegis.touched">please input name</small>
    </div>
    <div class="mb-4">
      <label class="block text-gray-700 text-sm font-bold mb-2" for="email">
        Email
      </label>
      <input
        class="input appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none "
        id="email"
        type="email"
        formControlName="email"
        placeholder="Email"
        name="email"
        ngModel
        required
      />
    </div>
    <div class="mb-6">
      <label class="block text-gray-700 text-sm font-bold mb-2" for="password">
        Password
      </label>
      <input
        class="input appearance-none border rounded w-full py-2 px-3 text-gray-700 mb-3 leading-tight focus:outline-none focus:shadow-outline"
        formControlName="password"
        id="password"
        type="password"
        name="password"
        maxlength="20"
        minlength="6"
        ngModel
        required
        placeholder="******************"
      />
    </div>

    <div class="flex items-center lg:justify-between sm:grid-rows-2 sm:grid-cols-1 gap-2">
      <button
        *ngIf="!isLoading"
        [disabled]="!formRegis.valid && isLoginMode"
        style="font-size:10px; width:100%"
        class='cursor-not-allowed bg-blue-500  text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline '
        type="submit"
      >
        {{ isLoginMode ? "Sign in" : "Sign-up" }}
      </button>
      <div *ngIf="isLoading">
        <app-spinner></app-spinner>
      </div>
      <button
      style="font-size:10px; width:100%"
        (click)="switchMode()"
        class="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-3 rounded focus:outline-none focus:shadow-outline"
        type="button"

      >
        Switch to {{ isLoginMode ? "Sign Up" : "Sign-In" }}
      </button>
    </div>

  </form>
  <p class="text-center text-gray-500 text-xs">&copy;2023 Angga</p>


</div>
